import React, { useState } from "react";
import axios from "axios";

const BlogForm = () => {
    const [blog, setBlog] = useState({
        title: "",
        category: "",
        tags: [],
        description: "",
        mainImage: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBlog({ ...blog, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post("https://apiqms.shigjeta.com/blogs", blog);
            alert("Blog added successfully!");
        } catch (error) {
            console.error("Error adding blog", error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="text" name="title" placeholder="Title" onChange={handleChange} required />
            <input type="text" name="category" placeholder="Category" onChange={handleChange} required />
            <input type="text" name="tags" placeholder="Tags (comma-separated)" onChange={(e) => setBlog({ ...blog, tags: e.target.value.split(",") })} />
            <textarea name="description" placeholder="Description" onChange={handleChange} required></textarea>
            <input type="text" name="mainImage" placeholder="Main Image URL" onChange={handleChange} />
            <button type="submit">Add Blog</button>
        </form>
    );
};

export default BlogForm;
